<!-- TreeNode 는 일종의 가상요소입니다. tree depth 를 증가시키면 안됩니다. -->
<template >
  <div class="parents" :style="styleObject">
    <!-- 자식 요소를 가지고있는 내부 노드.-->
    <tree-internal
      v-if="isInternalNode"
      :tree-item="treeItem"
      :tree-depth="treeDepth"
      :container-classes="containerClasses"
    >
      <template #internal="{ node, depth, expanded, toggle }">
        <slot
          name="internal"
          :node="node"
          :depth="depth"
          :expanded="expanded"
          :toggle="toggle"
        ></slot>
      </template>
      <template #leaf="{ node, depth }">
        <slot name="leaf" :node="node" :depth="depth"></slot>
      </template>
    </tree-internal>
    <!-- 자식 요소를 가지고있지 않은 잎 노드.-->
    <tree-leaf v-else :tree-depth="treeDepth" :tree-item="treeItem">
      <template #leaf="{ node, depth }">
        <slot name="leaf" :node="node" :depth="depth"></slot>
      </template>
    </tree-leaf>
  </div>
</template>

<script>
import TreeInternal from '@/views/newManual/TreeMenuSlot/TreeInternal'
import TreeBase from '@/views/newManual/TreeMenuSlot/TreeBase'
import TreeLeaf from '@/views/newManual/TreeMenuSlot/TreeLeaf'

export default {
  name: 'TreeNode',
  components: { TreeLeaf, TreeInternal },
  extends: TreeBase,
  inject: {
    root: {
      default: {
        autoIndent: true,
        autoIndentWidth: 20,
      },
    },
  },

  props: {
    containerClasses: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    styleObject() {
      const styles = {}
      if (this.root.autoIndent && this.treeDepth > 0) {
        styles.paddingLeft = `${this.root.autoIndentWidth}px`
      }
      return styles
    },
  },
}
</script>
<style>
    /*parents랑 children의 css 를 적용하기위해 작성했습니다.*/
    .parents{
        width: 100%;
    }

</style>
